import { render, staticRenderFns } from "./ThanksEN.vue?vue&type=template&id=68d022db&scoped=true&"
import script from "./ThanksEN.vue?vue&type=script&lang=js&"
export * from "./ThanksEN.vue?vue&type=script&lang=js&"
import style0 from "./ThanksEN.vue?vue&type=style&index=0&id=68d022db&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d022db",
  null
  
)

export default component.exports